import { format as dateFormat, parseISO } from 'date-fns'

export const format = (date = new Date(), formatString = 'MMMM yyyy') => {
  return dateFormat(parseISO(date), formatString)
}
